import { EHttpMethod } from '../common/enums/fetch.enum';

export default class WpApiRoutes {
  public method: EHttpMethod;
  public url: string;

  public static getAchievers = new WpApiRoutes(`/partner/posts`, EHttpMethod.GET);
  public static getBooklets = new WpApiRoutes(`/magazines`, EHttpMethod.GET);
  public static getInterestingForYou = new WpApiRoutes(`/interestingForYou`, EHttpMethod.GET);
  public static getKnowledgeBaseOverview = new WpApiRoutes(`/knowledgeBaseOverview`, EHttpMethod.GET);
  public static getMedia = new WpApiRoutes(`/press/itm`, EHttpMethod.GET);
  public static getMenuItems = new WpApiRoutes(`/getMenuItems`, EHttpMethod.GET);
  public static getMenuItemsForPartners = new WpApiRoutes(`/getMenuItemsForPartners`, EHttpMethod.GET);
  public static getNews = new WpApiRoutes(`/newsNewRoute`, EHttpMethod.GET);
  public static getPostId = new WpApiRoutes(`/getPostId`, EHttpMethod.GET);
  public static getPreviewPosts = new WpApiRoutes(`/blog/pposts`, EHttpMethod.GET);
  public static getRethinkArticles = new WpApiRoutes(`/articles/rethink`, EHttpMethod.GET);
  public static getShippingInfo = new WpApiRoutes(`/shippingInfo`, EHttpMethod.GET);
  public static getSingleProductData = new WpApiRoutes(`/products/infos/details`, EHttpMethod.GET);
  public static getSliderPosts = new WpApiRoutes(`/blog/sposts`, EHttpMethod.GET);
  public static getUrls = new WpApiRoutes(`/urls`, EHttpMethod.GET);

  constructor(url: string, method: EHttpMethod) {
    this.method = method;
    this.url = `/wp-json/ringana/v1${url}`;
  }
}
